import { Avatar, Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

interface Props {
  name: string;
}

export const LastUpdatedByAvatar: React.FC<Props> = ({ name }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mt: 2,
      }}
    >
      {name !== "Not available" && name !== "Not updated yet" && (
        <Avatar
          alt="user picture"
          sx={{ width: 25, height: 25 }}
          src="https://images.unsplash.com/photo-1463453091185-61582044d556?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
        ></Avatar>
      )}
      <Typography variant="body1" sx={{ ml: 1, fontSize: 13 }}>
        {name}
      </Typography>
    </Box>
  );
};

LastUpdatedByAvatar.propTypes = {
  name: PropTypes.string.isRequired,
};
